import { useEffect, useState, useCallback } from "react";
import { FolderNavigator } from "./FolderNavigator";
import { refreshTreeData, invalidateCache } from "../../services/proyectoEstructurado/proyectoEstructuracionTreeService";

export default function HomePage({ filtro }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [navigationState, setNavigationState] = useState(null);

  // Función para recargar datos
const reloadData = useCallback(async () => {
  try {
    setLoading(true);

    const response = await refreshTreeData(
      "actividad_13/tarea_135/indicador_17/medio_verificacion_16/",
      5
    );

    let newData = response.children || [];

    // 🔍 Si hay filtro recibido desde el otro componente
    if (filtro && filtro.rutaFiltrar) {
      // Paso 1: Buscar el proyecto (por ejemplo "E01. Inclusión Agroecológica...")
      const proyectoEncontrado = newData.find(
        (folder) => folder.name.includes(filtro.proyecto)
      );

      if (proyectoEncontrado && proyectoEncontrado.children) {
        // Paso 2: Buscar dentro del proyecto el paso específico (por ejemplo "Paso 9")
        const pasoEncontrado = proyectoEncontrado.children.find(
          (child) => child.name === filtro.paso.nombre_ruta
        );

        // Si lo encontró, mostrar solo ese paso
        if (pasoEncontrado) {
          newData = [pasoEncontrado];
        } else {
          // Si no hay coincidencia, mostrar solo el proyecto
          newData = [proyectoEncontrado];
        }
      } else {
        console.warn("⚠️ No se encontró el proyecto especificado en el filtro.");
      }
    }

    setData(newData);
  } catch (error) {
    console.error("❌ Error al recargar datos:", error);
  } finally {
    setLoading(false);
  }
}, [filtro]);


  // Función para invalidar cache
  const invalidatePathCache = useCallback(async (folderPath) => {
    try {
      await invalidateCache(folderPath);
    } catch (error) {
      console.error('❌ Error al invalidar cache:', error);
    }
  }, []);

  useEffect(() => {
    reloadData();
  }, []);

  if (loading) {
    return <p>Cargando datos...</p>;
  }

  return (
    <FolderNavigator 
      data={data} 
      onRefresh={reloadData}
      onInvalidateCache={invalidatePathCache}
      onNavigationChange={setNavigationState}
      preservedNavigationState={navigationState} // 👈 Pasamos el estado preservado
    />
  );
}